export const MOBILE_DESIGN_FOOTER_ID = 'designer-mobile-footer'
